import { cardTypesConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  request: null,
  response: null,
  error: null
};

export const viewCardType = (state = initialState, action) => {
  switch (action.type) {
    case cardTypesConstants.VIEW_CARDTYPE_REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false,
        request: action.id,
        response: null,
        error: null
      };
    case cardTypesConstants.VIEW_CARDTYPE_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case cardTypesConstants.VIEW_CARDTYPE_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        response: null,
        error: action.error
      };
    case cardTypesConstants.VIEW_CARDTYPE_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
